import { useEffect, useMemo, useRef, useSyncExternalStore, type ReactNode } from 'react';

import { RealtimeContext } from '../../shared/api/realtime';
import { tokenStore } from '../../shared/api/token-store';
import { RealtimeConnection } from '../../shared/realtime';

export const RealtimeProvider = ({ children }: { children: ReactNode }) => {
  const token = useSyncExternalStore(tokenStore.subscribe, tokenStore.access);
  const held = useRef<RealtimeConnection | null>(null);
  held.current ??= new RealtimeConnection();
  const connection = held.current;

  useEffect(() => {
    if (token) connection.connect();
    else connection.disconnect();
  }, [connection, token]);

  // Separate unmount-only effect: an orphaned socket holds a server session, capped per organization.
  useEffect(() => () => connection.disconnect(), [connection]);

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    (window as unknown as Record<string, unknown>).hookpipeRealtime = connection;
  }, [connection]);

  const value = useMemo(() => ({ connection }), [connection]);

  return <RealtimeContext.Provider value={value}>{children}</RealtimeContext.Provider>;
};
